import { InspectedBrandNormal } from "./inspected-brand-normal.component";
import { InspectedBrandSmall } from "./inspected-brand-small.component";
import styles from "./inspected-brand.module.css";

export type InspectedBrandProps = {
  size?: "normal" | "small";
};

export function InspectedBrand({ size = "normal" }: InspectedBrandProps) {
  return (
    <div className={styles.Container}>
      {size === "normal" && <InspectedBrandNormal />}
      {size === "small" && <InspectedBrandSmall />}
    </div>
  );
}
